// Centralised German language file for UI text in Weather App
// Please keep keys in sync with en.ts for consistency

const de = {
  app: {
    title: 'WeatherUp!',
    welcome: 'Willkommen bei WeatherUp! 🌤️',
    subtitle: 'Weltwetter',
    instructions: 'Geben Sie einen Städtenamen ein, um das Wetter zu prüfen und über die aktuellen Bedingungen informiert zu bleiben. Beginnen Sie, indem Sie in das Suchfeld oben tippen. Viel Spaß beim Erkunden!'
  },
  weather: {
    loading: 'Wetterdaten werden geladen...',
    cardTitle: 'Wetter für',
    currentTemp: 'Aktuelle Temperatur',
    min: 'Min:',
    max: 'Max:',
    localTime: 'Ortszeit',
    details: 'Wetterdetails',
    humidity: 'Luftfeuchtigkeit',
    pressure: 'Luftdruck',
    windSpeed: 'Windgeschwindigkeit',
    visibility: 'Sichtweite',
    feelsLike: 'Gefühlt',
  },
  search: {
    placeholder: 'Stadt suchen...',
    ariaLabel: 'Stadt suchen',
    button: 'Suchen',
    noResults: 'Keine Orte gefunden.'
  }
};

export default de;
